import { httpGet } from '../components/utils';

const logout = (ref) => {
    httpGet('/logout').finally(() => {
        window.location.href = '/login';
    });
};

export default logout;
